import { useCallback, useEffect, useRef } from "react"

import openWorkosAuthPopup from "src/utils/openWorkosAuthPopup"

// React wrapper around openWorkosAuthPopup. Tracks the active popup's
// cancel function and clears it on unmount so we don't leak a poller or
// message listener when the parent component goes away mid-flow.
export default function usePopupAuth({ onSuccess, onError }) {
  const cancelRef = useRef(null)
  const onSuccessRef = useRef(onSuccess)
  const onErrorRef = useRef(onError)

  useEffect(() => {
    onSuccessRef.current = onSuccess
  }, [onSuccess])
  useEffect(() => {
    onErrorRef.current = onError
  }, [onError])

  useEffect(() => () => cancelRef.current?.(), [])

  return useCallback((returnTo) => {
    cancelRef.current?.()
    cancelRef.current = openWorkosAuthPopup({
      returnTo,
      onSuccess: () => onSuccessRef.current?.(),
      onError: (message) => onErrorRef.current?.(message),
    })
  }, [])
}
